import { memo } from 'react'

//BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023  - Start
const ChartWidget = ({ chartUrl, halfHeight = false, isPopOut = false }) => {
    return (
        <div className={`${isPopOut ? 'vh-100 vw-100' : halfHeight ? ' sidetray-chart-wrapper side-overview-chart-halfheight' : 'sidetray-chart-wrapper'}`}>
            {/* BT-117493 : Vaibhav Singh : width fixed for chart*/}
            <iframe className='h-100 w-100' id='chartObject' src={chartUrl} title='Analysis' />
        </div>
    );
};
//BT-112978 Using Chart key constants from AppInfo + testing  : Displaying chart by using chart constants : Manasa B : 10/07/2023  - End
export default memo(ChartWidget);